export const MAX_DESCRIPTION_LENGTH = 1200;
